<template>
  <div>
    <div class="setting">
      <div class="title">设置你想要接收的消息类型</div>
      <!-- 普通通知 -->
      <div class="setMain">
        <el-row type="flex" class="row-bg" justify="space-between" v-for="(item, index) in normalList" :key="index">
          <el-col :span="20" class="rowLeft">
            <p>{{ item.name }}</p>
            <span>{{ item.description || '' }}</span>
          </el-col>
          <el-col :span="3" class="rowRight">
            <div class="status" @click="openSetting(item)">{{ computeItemStatus(item) }} <i
                class="el-icon-arrow-right"></i></div>
          </el-col>
        </el-row>
      </div>
      <!-- 营销类通知，单独分隔 -->
      <div class="setMain marketing" v-if="marketingList.length">
        <el-row type="flex" class="row-bg" justify="space-between" v-for="(item, index) in marketingList" :key="index">
          <el-col :span="20" class="rowLeft">
            <p>{{ item.name }}</p>
            <span>{{ item.description || '' }}</span>
          </el-col>
          <el-col :span="3" class="rowRight">
            <div class="status" @click="openSetting(item)">{{ computeItemStatus(item) }} <i
                class="el-icon-arrow-right"></i></div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog title='账户通知消息' :visible.sync='dialogFormVisible' width='550px' append-to-body
      custom-class='dialog-offset-top' @close='close'>
      <el-row type="flex" class="row-bg" justify="space-between" v-for="(item, index) in settingList" :key="index">
        <el-col :span="20">
          <p class="label" :class="!item.hasSwitch ? 'noSwitchLabel' : ''">{{ item.label }}</p>
        </el-col>
        <el-col :span="3">
          <div class="status">
            <el-switch v-if="item.hasSwitch" v-model="item.value" :active-value="1" :inactive-value="0"
              @change="(val) => onSwitchChange(item.field, val)"></el-switch>
          </div>
        </el-col>
      </el-row>
      <div slot='footer' class='dialog-footer'>
        <el-button @click='dialogFormVisible = false' class="cancelBtn">取消</el-button>
        <el-button type='primary' @click='saveSetting' class="confirmBtn" :loading="confirmLoading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  mesUpdateNoticeGrant,
  mesSearchNoticeGrant,
} from "@http/message";
import { mapState } from "vuex";
const STATUS_LIST = [
  { status: 0, text: '不允许' },
  { status: 1, text: '部分允许' },
  { status: 2, text: '已允许' },
]

// 弹窗配置项：按 UI 顺序定义，hasSwitch 控制是否显示开关
const DIALOG_CONFIG = [
  { field: 'allowNotify', label: '允许通知', hasSwitch: true },
  { field: 'system', label: '通知形式', hasSwitch: false },
  { field: 'msgEnabled', label: '应用内消息中心', hasSwitch: true },
  { field: 'pushEnabled', label: '应用外推送', hasSwitch: true },
  { field: 'smsEnabled', label: '手机短信', hasSwitch: true, hideForNonMarketing: true },
]
export default {
  name: "history",
  components: {},
  data() {
    return {
      normalList: [],
      marketingList: [],
      currentItem: null,
      settingList: [],
      dialogFormVisible: false,
      confirmLoading: false,
      isMarketing: false,
    }
  },
  methods: {
    async initData() {
      let res = await mesSearchNoticeGrant()
      // noticeKind: 0=普通通知，1=营销类通知
      this.normalList = res.filter(item => item.noticeKind === 0)
      this.marketingList = res.filter(item => item.noticeKind === 1)
    },
    openSetting(item) {
      this.currentItem = item
      // 非营销类通知隐藏手机短信行
      const isMarketing = item.noticeKind === 1
      // 根据配置项生成弹窗数据，按 UI 顺序排列
      this.settingList = DIALOG_CONFIG.map(conf => {
        // 非营销类且不显示短信时，整行隐藏
        if (conf.hideForNonMarketing && !isMarketing) return null

        const rawValue = item[conf.field]
        let value = rawValue ?? (conf.hasSwitch ? 1 : null)

        if (conf.field === 'allowNotify') {
          // 允许通知是虚拟字段：只要三项中有一项打开，就为打开
          const sms = item.smsEnabled === 1 || item.smsEnabled === '1'
          const push = item.pushEnabled === 1 || item.pushEnabled === '1'
          const msg = item.msgEnabled === 1 || item.msgEnabled === '1'
          value = (sms || push || msg) ? 1 : 0
        } else if (conf.hasSwitch) {
          // 其他开关字段：0 或 "0" 是关闭，否则开启
          value = (value === 0 || value === '0') ? 0 : 1
        }
        return {
          field: conf.field,
          label: conf.label,
          hasSwitch: conf.hasSwitch,
          value: value,
        }
      }).filter(Boolean)
      this.dialogFormVisible = true
    },
    async saveSetting() {
      this.confirmLoading = true
      const smsSetting = this.settingList.find(i => i.field === 'smsEnabled')
      const pushEnabled = this.settingList.find(i => i.field === 'pushEnabled')?.value
      const msgEnabled = this.settingList.find(i => i.field === 'msgEnabled')?.value
      const allowNotify = this.settingList.find(i => i.field === 'allowNotify')?.value

      // 非营销类弹窗不显示 smsEnabled，但需要跟随 allowNotify 同步变化
      const smsEnabled = smsSetting
        ? smsSetting.value
        : (allowNotify === 1 ? 1 : 0)

      const params = {
        noticeKind: this.currentItem.noticeKind,
        noticeType: this.currentItem.noticeType,
        smsEnabled,
        pushEnabled,
        msgEnabled,
      }
      mesUpdateNoticeGrant(params).then(async res => {
        this.dialogFormVisible = false
        this.confirmLoading = false

        // 清空列表后重新获取，确保数据刷新
        this.normalList = []
        this.marketingList = []
        this.$msg("操作成功", "success");
        await this.initData()
      }).catch(err => {
        this.dialogFormVisible = false
        this.confirmLoading = false
      })
    },
    onSwitchChange(field, val) {
      if (field === 'allowNotify') {
        // 允许通知切换时，同步控制其余所有可见开关
        const target = val
        this.settingList.forEach(item => {
          if (['smsEnabled', 'pushEnabled', 'msgEnabled'].includes(item.field)) {
            item.value = target
          }
        })
      } else {
        // 其余开关任一变化时，同步更新允许通知
        // 只根据当前可见的开关判断
        const switches = this.settingList.filter(i => ['smsEnabled', 'pushEnabled', 'msgEnabled'].includes(i.field))
        const allow = this.settingList.find(i => i.field === 'allowNotify')
        if (allow && switches.length > 0) {
          allow.value = switches.some(s => s.value === 1) ? 1 : 0
        }
      }
    },
    computeItemStatus(item) {
      const sms = item.smsEnabled === 1 || item.smsEnabled === '1'
      const push = item.pushEnabled === 1 || item.pushEnabled === '1'
      const msg = item.msgEnabled === 1 || item.msgEnabled === '1'
      const count = (sms ? 1 : 0) + (push ? 1 : 0) + (msg ? 1 : 0)
      if (count === 0) return '不允许'
      if (count === 3) return '已允许'
      return '部分允许'
    },
    close() {

    },
  },
  created() {
    this.initData()
  }
}
</script>

<style scoped lang="less">
@import "./setting.less";

.setting {
  box-sizing: border-box;
  padding: 18px 30px;
  height: 100%;

  .title {
    font-size: 16px;
    color: #333;
  }

  .setMain {
    margin-top: 20px;
    background: #fff;
    border-radius: 16px;

    .el-row {
      width: 70%;
      margin: 0 auto;
      padding: 20px 0;
      border-bottom: 1px solid #E0E0E2;
      align-items: center;

      .rowLeft {
        p {
          font-size: 16px;
          font-weight: bold;
          color: #000;
        }

        span {
          font-size: 12px;
          color: #959595;
          margin-top: 8px;
          display: inline-block;
        }
      }

      .rowRight {
        .status {
          font-size: 14px;
          color: #666666;
          cursor: pointer;

          &:hover {
            color: #409EFF;
          }
        }
      }
    }

    .el-row:last-child {
      border-bottom: none;
    }
  }

  // 营销类通知，与前面有间隔
  .setMain.marketing {
    margin-top: 30px;
  }
}
</style>